<template lang="pug">
    create-or-Edit(:modalDisplay="true", @save="classroomCreated")
</template>

<script>
import CreateOrEdit from "@/components/classroom/CreateOrEdit";

export default {
	components: {
		CreateOrEdit
	},
	props: {
		navigateAfter: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		classroomCreated(classroom) {
			if (this.navigateAfter) {
				this.$router.push({ name: "classroom.show", params: { class: classroom.id } });
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/Create.vue